import React from "react";

import Logo from "../../assets/img/Logo_ComVocêONatalSeTransforma_Natal2025_v1.png";

import "./styles.css";

function Loading() {
  return (
    <div className="loading-wrapper">
      <img src={Logo} alt="Natal com #TimeCEJAM" />
    </div>
  );
}

export default Loading;
